import type { NodeDetailTab } from './types'
import styles from './nodeDetail.module.css'
import { cx } from './utils'

interface NodeDetailTabsProps {
  activeTab: NodeDetailTab
  onChange: (tab: NodeDetailTab) => void
  recordingJobCount: number
  uploading: boolean
  cameraFileCount: number
  inferenceFileCount: number
  modelAlertCount: number
}

export function NodeDetailTabs({
  activeTab,
  onChange,
  recordingJobCount,
  uploading,
  cameraFileCount,
  inferenceFileCount,
  modelAlertCount,
}: NodeDetailTabsProps) {
  const tabs: Array<{ key: NodeDetailTab; label: string; count?: number }> = [
    { key: 'overview', label: 'Overview' },
    { key: 'camera_recordings', label: 'Manual Recordings', count: cameraFileCount },
    { key: 'inference_recordings', label: 'Inference Recordings', count: inferenceFileCount },
    { key: 'model_deploy', label: 'Model Deploy', count: modelAlertCount || undefined },
  ]

  return (
    <div className={styles.detailTabsShell}>
      <div role="tablist" aria-label="Node detail sections" className={styles.detailTabList}>
        {tabs.map((tab) => {
          const active = activeTab === tab.key
          return (
            <div
              key={tab.key}
              role="tab"
              aria-selected={active}
              onMouseDown={(event) => {
                event.preventDefault()
              }}
              onClick={(event) => {
                event.currentTarget.blur()
                onChange(tab.key)
              }}
              className={cx(styles.detailTabButton, active && styles.detailTabButtonActive)}
            >
              <span>{tab.label}</span>
              {tab.count != null && (
                <span className={cx(styles.detailTabCount, active && styles.detailTabCountActive)}>
                  {tab.count}
                </span>
              )}
            </div>
          )
        })}
      </div>
      <div className={styles.detailTabStatus}>
        <span className={cx(
          styles.detailStatusPill,
          recordingJobCount > 0 && styles.detailStatusPillRecording,
        )}>
          {recordingJobCount > 0 ? `Recording ${recordingJobCount}` : 'Recording idle'}
        </span>
        <span className={cx(styles.detailStatusPill, uploading && styles.detailStatusPillUpload)}>
          {uploading ? 'Upload running' : 'Upload idle'}
        </span>
      </div>
    </div>
  )
}
